<template>
    <OverlayLoader :isLoading="!requestsLoaded">
        <main class="page page-dashboard">
            <div class="container">
                <PageHeader
                    :title="$translate.text('general.requests')"
                />

                <WhiteTable :labels="[$translate.text('general.date'), $translate.text('general.company.name'), $translate.text('general.subscription.option')]">
                    <template slot="table-data">
                        <template v-for='request in requests'>
                            <tr v-for="option in request.subscription_options" :key="option.id">
                                <td>{{ option.pivot.created_at }}</td>
                                <td>{{ request.company_name }}</td>
                                <td>{{ option.max_sync }}</td>
                                <td class="align-right">
                                    <i v-if='!option.pivot.active' class="fal fa-check" @click="allowOption(request, option)" v-tooltip.bottom="$translate.text('tooltip.allow_custom_subscription_option')"></i>
                                    <i v-if='option.pivot.active' class="fal fa-ban" @click="disallowOption(request, option)" v-tooltip.bottom="$translate.text('tooltip.disallow_custom_subscription_option')"></i>
                                </td>
                            </tr>
                        </template>
                        <tr v-if="!requests.length">
                            <td colspan="3">{{ t('general.no_results_found') }}</td>
                        </tr>
                    </template>
                </WhiteTable>
            </div>
        </main>
    </OverlayLoader>
</template>
<script>
import handleError from '@/helpers/error';
import OverlayLoader from '@/components/OverlayLoader/OverlayLoader';
import PageHeader from '@/components/PageHeader/PageHeader';
import WhiteTable from '@/components/Table/WhiteTable';
import swal from 'sweetalert';

export default {
    name: 'AdminRequests',

    components: {
        PageHeader,
        OverlayLoader,
        WhiteTable,
    },

    data() {
        return {
            requests: [],
            requestsLoaded: false,
        };
    },

    created() {
        this.getRequests();
    },

    methods: {
        getRequests() {
            this.requestsLoaded = false;

            this.API.admin.requests.index({ search: this.search, ...this.dates })
                .then((response) => {
                    const data = response.data.data;
                    this.requests = data;
                    this.requestsLoaded = true;
                })
                .catch((error) => {
                    handleError({
                        error,
                        message: this.$translate.text('alert.whoops'),
                    });
                });
        },

        allowOption(request, option) {
            swal(
                this.$translate.text('alert.confirm.allow'),
                {
                    buttons: {
                        cancel: this.$translate.text('general.no'),
                        confirm: this.$translate.text('general.yes'),
                    },
                },
            ).then((value) => {
                if (value) {
                    this.requestsLoaded = false;

                    this.API.admin.requests.allow(request.id, option.id)
                        .then(() => {
                            this.getRequests();
                        })
                        .catch((error) => {
                            handleError({
                                error,
                                message: this.$translate.text('alert.whoops'),
                            });
                        });
                }
            });
        },

        disallowOption(request, option) {
            swal(
                this.$translate.text('alert.confirm.disallow'),
                {
                    buttons: {
                        cancel: this.$translate.text('general.no'),
                        confirm: this.$translate.text('general.yes'),
                    },
                },
            ).then((value) => {
                if (value) {
                    this.requestsLoaded = false;

                    this.API.admin.requests.disallow(request.id, option.id)
                        .then(() => {
                            this.getRequests();
                        })
                        .catch((error) => {
                            handleError({
                                error,
                                message: this.$translate.text('alert.whoops'),
                            });
                        });
                }
            });
        },
    },
};
</script>

<style scoped>
    .white-table {
        padding-top: 20px;
    }

    input {
        flex: 6;
        border: 0;
        border-radius: 4px;
        padding: 12px 16px;
        font-size: 16px;
        margin-right: 10px;

        &:disabled {
            background-color: darken(#fff, 5%);
            cursor: not-allowed;
        }
    }
</style>
